import Repository from './Repository'
import { API_BASE_PATH } from './ApiPath'

const ADMIN = API_BASE_PATH.ADMIN
const PLUGIN = API_BASE_PATH.PLUGIN

export default {
  getGames(season_id: number, queries: any) {
    return Repository.get(`${ADMIN}/season/${season_id}/game`, { params: queries })
  },
  getGame(season_id: number, game_id: number) {
    return Repository.get(`${ADMIN}/season/${season_id}/game/${game_id}`)
  },
  postGames(season_id: number, data: any) {
    const dataJson = JSON.stringify(data)
    const config = { headers: {'Content-Type': 'application/json'} }

    return Repository.post(`${ADMIN}/season/${season_id}/game`, dataJson, config)
  },
  updateGame(season_id: number, data: any) {
    const dataJson = JSON.stringify(data)
    const config = { headers: {'Content-Type': 'application/json'} }

    return Repository.put(`${ADMIN}/season/${season_id}/game`, dataJson, config)
  },
  deleteGames(season_id: number, params: any) {
    return Repository.delete(`${ADMIN}/season/${season_id}/game`, { data: params })
  },
  startGame(season_id: number, game_id: number) {
    return Repository.put(`${ADMIN}/season/${season_id}/game/${game_id}/start`)
  },
  stopGame(season_id: number, game_id: number, data: any) {
    return Repository.put(`${ADMIN}/season/${season_id}/game/${game_id}/stop`, data)
  },
  getGameLeague(queries: any) {
    return Repository.get(`${PLUGIN}/league`, { params: queries })
  },
  postGameLeague(season_id: number, data: any) {
    return Repository.post(`${ADMIN}/season/${season_id}/game/league`, data)
  },
  getGameTournament(queries: any) {
    return Repository.get(`${PLUGIN}/tournament`, { params: queries })
  },
  deleteGroupGames(season_id: number, params: any) {
    return Repository.delete(`${ADMIN}/season/${season_id}/game/group`, { data: params })
  }
}